export const ADVISOR_BOOK_IMPORT_TYPE = 'advisor_onboarding_book' as const;

export const ADVISOR_BOOK_IMPORTABLE_TYPE = 'AdvisorOnboarding::Enrollment' as const;

export const ADVISOR_BOOK_UPLOAD_ACCEPTED_EXTENSIONS = ['xlsx'] as const;

export const ADVISOR_BOOK_IMPORT_POLL_INTERVAL_MS = 1000;

// Base64 file payloads can exceed Apollo's default 30s TimeoutLink; allow headroom for
// encode + upload before server-side parsing takes over via polling.
export const ADVISOR_BOOK_IMPORT_UPLOAD_TIMEOUT_MS = 120_000;

export const ADVISOR_BOOK_IMPORT_TERMINAL_FAILURE_STATUSES = ['failed', 'cancelled'] as const;

// `no_data` is terminal-but-nothing-imported. It stays here so an empty upload still
// settles into review instead of polling forever — the review step is what tells the
// advisor their book came back empty.
export const ADVISOR_BOOK_IMPORT_SUCCESS_STATUSES = ['completed', 'partially_completed', 'no_data'] as const;
